/**
 * Centralized format configuration for WAW Travel.
 *
 * All date and price formatting across the app should read from this config
 * so that format changes (locale, decimals, separators) only need to be
 * made in one place.
 *
 * Values can be overridden via Vite env variables (VITE_APP_FORMAT_*).
 */

export interface FormatConfig {
  /** BCP-47 locale used for number/date formatting, e.g. "de-DE" for European comma decimals */
  locale: string;
  /** Number of decimal places for prices */
  priceDecimals: number;
  /** Luxon date format token, e.g. "dd/MM/yyyy" */
  dateFormat: string;
  /** Luxon datetime format token, e.g. "dd/MM/yyyy HH:mm" */
  dateTimeFormat: string;
  /** Currency symbol shown alongside prices */
  currencySymbol: string;
  /** Currency ISO code for Intl.NumberFormat currency style */
  currencyCode: string;
  /** Timezone used for datetime display */
  timezone: string;
}

const env = import.meta.env;

export const formatConfig: FormatConfig = {
  locale: env.VITE_APP_FORMAT_LOCALE || "de-DE",
  priceDecimals: Number(env.VITE_APP_FORMAT_PRICE_DECIMALS || 2),
  dateFormat: env.VITE_APP_FORMAT_DATE || "dd/MM/yyyy",
  dateTimeFormat: env.VITE_APP_FORMAT_DATETIME || "dd/MM/yyyy HH:mm",
  currencySymbol: env.VITE_APP_FORMAT_CURRENCY_SYMBOL || "€",
  currencyCode: env.VITE_APP_FORMAT_CURRENCY_CODE || "EUR",
  timezone: env.VITE_APP_FORMAT_TIMEZONE || "Europe/Madrid",
};

export default formatConfig;
